// ✅ src/services/functionalityService.js
import axiosClient from "../api/axiosClient";

// ============================================================
// ✅ 1️⃣ Get list of functionalities
// ============================================================
export const getFunctionalities = async (params = {}) => {
  try {
    const res = await axiosClient.get("/api/admin/functionality/list", { params });
    return {
      success: true,
      data: Array.isArray(res?.data?.data) ? res.data.data : [],
    };
  } catch (err) {
    console.error("❌ getFunctionalities failed:", err);
    return { success: false, data: [] };
  }
};

// ============================================================
// ✅ 2️⃣ Add new functionality
// ============================================================
export const addFunctionality = async (payload) => {
  try {
    const res = await axiosClient.post("/api/admin/functionality/create", payload);
    return { success: true, data: res.data };
  } catch (err) {
    console.error("❌ addFunctionality failed:", err);
    return { success: false, message: err?.response?.data?.message || "Failed to add functionality" };
  }
};

// ============================================================
// ✅ 3️⃣ Get functionality by ID
// ============================================================
export const getFunctionalityById = async (id) => {
  try {
    const res = await axiosClient.get(`/api/admin/functionality/${id}`);
    return res.data;
  } catch (err) {
    console.error("❌ getFunctionalityById failed:", err);
    return null;
  }
};

// ============================================================
// ✅ 4️⃣ Update functionality
// ============================================================
export const updateFunctionality = async (id, payload) => {
  try {
    const res = await axiosClient.put(`/api/admin/functionality/update/${id}`, payload);
    return { success: true, data: res.data };
  } catch (err) {
    console.error("❌ updateFunctionality failed:", err);
    return { success: false, message: err?.response?.data?.message || "Update failed" };
  }
};

// ============================================================
// ✅ 5️⃣ Delete functionality
// ============================================================
export const deleteFunctionality = async (id) => {
  try {
    const res = await axiosClient.delete(`/api/admin/functionality/delete/${id}`);
    return { success: true, data: res.data };
  } catch (err) {
    console.error("❌ deleteFunctionality failed:", err);
    return { success: false, message: err?.response?.data?.message || "Delete failed" };
  }
};

// ============================================================
// ✅ 6️⃣ Export all
// ============================================================
export default {
  getFunctionalities,
  addFunctionality,
  getFunctionalityById,
  updateFunctionality,
  deleteFunctionality,
};
